<template>
  <v-dialog :value="model.active" width="400" persistent>
    <v-card v-if="selected">
      <div class="d-flex justify-space-between align-center pr-2">
        <v-card-title class="text-h6 font-weight-bold">
          <v-icon left>{{ selected.id ? 'mdi-pencil' : 'mdi-plus' }}</v-icon>
          {{ selected.id ? 'Update' : 'Add' }} Type
        </v-card-title>
        <v-btn icon @click="closeDialog"><v-icon>fa-close</v-icon></v-btn>
      </div>
      <v-divider></v-divider>
      <v-card-text class="pt-5">
        <v-form v-model="model.valid">
          <v-text-field
            outlined
            dense
            clearable
            label="Name"
            :rules="[formRules.required]"
            placeholder="Enter Name..."
            v-model="selected.name">
          </v-text-field>
          <v-autocomplete
            v-model="selected.icon"
            outlined
            dense
            clearable
            :items="icons"
            label="Select Icon"
            :rules="[formRules.required]"
            placeholder="Select Icon...">
            <template #item="{ item, on, attrs }">
              <v-list-item v-on="on" v-bind="attrs">
                <v-list-item-icon class="mr-1">
                  <v-icon>{{ item }}</v-icon>
                </v-list-item-icon>
                <v-list-item-title>{{ item }}</v-list-item-title>
              </v-list-item>
            </template>
            <template #selection="{ item }">
              <div class="d-flex align-center" dense>
                <v-icon left>{{ item }}</v-icon>
                <div>{{ item }}</div>
              </div>
            </template>
          </v-autocomplete>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn color="red" elevation="0" text @click="closeDialog"> close </v-btn>
        <v-spacer></v-spacer>
        <v-btn elevation="0" :disabled="!model.hasChanges" @click="discard"> discard </v-btn>
        <v-btn
          color="primary"
          :loading="updateLoading"
          elevation="0"
          @click="saveChanges"
          :disabled="!model.valid || !model.hasChanges">
          {{ selected.id ? 'Update' : 'Save' }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import { $isEqual } from '@Utils';
  import formRules from '@Share/config/form-rules';
  import { mapGetters } from 'vuex';
  import { $splitCamelCase } from '../../../../../utils';
  const mdi = require('@mdi/js');

  export default {
    name: 'edit-task-type',
    data() {
      return {
        selected: {},
        selectedCemented: {},
        formRules,
        model: {
          active: false,
          loading: false,
          valid: true,
          hasChanges: false,
        },
        icons: Object.keys(mdi).map((icon) => $splitCamelCase(icon, '-').toLowerCase()),
      };
    },
    computed: {
      ...mapGetters('TASK_MANAGER', {
        updateLoading: 'GET_UPDATE_LOADING',
      }),
    },
    methods: {
      open(item) {
        this.model.active = true;
        if (item) this.selected = structuredClone(item);
        this.cementSelected();
      },
      saveChanges() {
        this.selected.facilityId = this.$route.params.id;
        this.$store.dispatch('TASK_MANAGER/UPDATE', this.selected).then((data) => {
          this.$emit('updateSelected', data);
          this.cementSelected();
          this.closeDialog();
        });
      },
      reset() {
        this.model.active = false;
        this.selected = {};
        this.selectedCemented = {};
      },
      closeDialog() {
        if (this.model.hasChanges) {
          const answer = window.confirm('You have unsaved changes on this page! leave anyway?');
          if (answer) {
            this.reset();
            this.discard();
          }
        } else {
          this.reset();
        }
      },
      discard() {
        this.selected = structuredClone(this.selectedCemented);
        this.model.hasChanges = false;
      },
      cementSelected() {
        this.selectedCemented = structuredClone(this.selected);
        this.checkForChanges();
      },
      checkForChanges() {
        if (!this.model.active) return;

        this.model.hasChanges = !$isEqual(this.selected, this.selectedCemented);
      },
    },
    watch: {
      selected: {
        handler() {
          this.checkForChanges();
        },
        deep: true,
      },
    },
  };
</script>
